import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { PRIORITY_META } from "../lib/meta";
import { eur } from "../lib/format";
import { MapPin } from "lucide-react";

export default function Retreats() {
  const [packages, setPackages] = useState([]);
  const [areas, setAreas] = useState([]);
  const [area, setArea] = useState("");
  const [theme, setTheme] = useState("");

  useEffect(() => { api.get("/areas").then((r) => setAreas(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    const params = {};
    if (area) params.area = area;
    if (theme) params.theme = theme;
    api.get("/packages", { params }).then((r) => setPackages(r.data)).catch(() => {});
  }, [area, theme]);

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-16" data-testid="retreats-page">
      <div className="hairline mb-6" />
      <span className="overline">The Collection</span>
      <h1 className="font-heading text-6xl md:text-7xl mt-3 mb-10 text-rr-ivory">Choose Your Sanctuary</h1>

      <div className="flex flex-wrap gap-2.5 mb-12">
        <Chip active={!area && !theme} onClick={() => { setArea(""); setTheme(""); }} testid="filter-all">All</Chip>
        {areas.map((a) => <Chip key={a.slug} active={area === a.slug} onClick={() => setArea(area === a.slug ? "" : a.slug)} testid={`filter-area-${a.slug}`}>{a.name}</Chip>)}
        <span className="w-px bg-rr-line mx-2" />
        {Object.entries(PRIORITY_META).map(([key, meta]) => <Chip key={key} active={theme === key} onClick={() => setTheme(theme === key ? "" : key)} testid={`filter-theme-${key}`}>{meta.label}</Chip>)}
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {packages.map((p) => (
          <Link key={p.slug} to={`/retreats/${p.slug}`} data-testid={`retreat-card-${p.slug}`} className="group block card-lift">
            <div className="relative h-[460px] overflow-hidden rounded-xl">
              <img src={p.hero_image} alt={p.name} className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-105" />
              <div className="absolute inset-0 hero-overlay-soft" />
              <div className="absolute top-5 left-5 flex items-center gap-1.5"><MapPin className="w-4 h-4 text-rr-gold" strokeWidth={1.4} /><span className="text-sm text-rr-ivory/90">{p.area}</span></div>
              <div className="absolute bottom-5 left-6 right-6">
                <h3 className="font-heading text-3xl text-rr-ivory">{p.name}</h3>
                <p className="text-rr-ivory/70 text-sm mt-1.5 line-clamp-2">{p.tagline}</p>
              </div>
            </div>
            <div className="flex items-center justify-between mt-4">
              <p className="text-rr-gold text-sm">from {eur(p.price_per_night_eur)}<span className="text-rr-muted"> / night</span></p>
              <span className="text-xs text-rr-muted">{p.durations?.join(" · ")} nights</span>
            </div>
          </Link>
        ))}
      </div>
      {packages.length === 0 && <p className="text-rr-muted mt-10">No retreats match your selection.</p>}
    </div>
  );
}

function Chip({ children, active, onClick, testid }) {
  return (
    <button onClick={onClick} data-testid={testid}
      className={`text-[11px] uppercase tracking-[0.1em] px-5 py-2.5 rounded-full border transition-all ${
        active ? "bg-rr-gold text-rr-bg border-rr-gold" : "border-rr-line text-rr-ivory/70 hover:border-rr-gold hover:text-rr-ivory"}`}>
      {children}
    </button>
  );
}
